var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 19.183",
    fill: "currentColor",
    enableBackground: "new 0 0 35 19.183",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.381c0.06-0.143,0.113-0.29,0.183-0.429c0.307-0.618,0.806-0.937,1.498-0.95C1.783,0,1.886,0,1.988,0 c10.343,0,20.687,0,31.03,0.002c0.227,0,0.461-0.007,0.68,0.041c1.165,0.255,1.688,1.654,0.983,2.617 c-0.1,0.137-0.222,0.26-0.342,0.38c-5.154,5.156-10.309,10.311-15.465,15.466c-0.902,0.902-1.837,0.903-2.738,0.002 C11.037,13.41,5.94,8.31,0.837,3.215C0.479,2.857,0.149,2.492,0,1.996C0,1.791,0,1.586,0,1.381z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow2);
export default __webpack_public_path__ + "static/media/down-arrow_2.44cbdb8ed482dbcfe9775fc34b8acfff.svg";
export { ForwardRef as ReactComponent };